import { MutationTree } from "vuex";
import { IPracticeState } from "@/store/modules/practice/types";

import {
  IContentSection,
  IPassage,
  IQuestion,
} from "@/store/modules/content/types";

type PracticeMutationsTree = MutationTree<IPracticeState>;

export const mutations: PracticeMutationsTree = {
  setSections(state: IPracticeState, sections: IContentSection[]) {
    state.sections = sections;
  },

  setSection(state: IPracticeState, section: IContentSection) {
    state.section = section;
  },

  setQuestions(state: IPracticeState, questions: IQuestion[]) {
    state.questions = questions;
  },

  setPassages(state: IPracticeState, passages: IPassage[]) {
    state.passages = passages;
  },

  setCompletedSections(state: IPracticeState, sections: {}) {
    state.completedSections = { ...state.completedSections, ...sections };
  },
};
